import { CardEmptyState, CardAction, ChickletHoverActions, ChickletPrimaryDisplayLabel } from '../constants/BehaviorTypes';
import getCreditMemoChickletHoverActions from '../behaviors/creditMemo/getCreditMemoChickletHoverActions';
import CreditMemoCardEmptyState from '../behaviors/creditMemo/CreditMemoCardEmptyState';
import CreditMemoChickletPrimaryDisplayLabel from '../behaviors/creditMemo/CreditMemoChickletPrimaryDisplayLabel';
const EmptyCardAction = () => null;
export const CreditMemo = {
  [CardEmptyState]: () => CreditMemoCardEmptyState,
  [ChickletPrimaryDisplayLabel]: () => CreditMemoChickletPrimaryDisplayLabel,
  [CardAction]: () => EmptyCardAction,
  [ChickletHoverActions]: () => getCreditMemoChickletHoverActions
};